// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"5a6bbbb85f938f7572d5","293":"9386f6fbd57281175df8"}[chunkId] + ".js";
};